module.exports = __webpack_public_path__ + "static/media/logo_h_t_ajustat.26e157c9.png";